import { SelectedTenant } from '@/config/initialState';
import {
  CreateCoatingParams,
  PaidyConfirmCoatingParams,
  PrepareCoatingPaymentParams,
} from '@/types/api/coatingApi';
import { GmoPaymentUrlGenerationParams } from '@/types/api/payment';
import { selectedTenantFor } from '@/utils/selectedTenant';

// Step4 の申込データと、決済開始時点の顧客・切り替え先が一致する場合だけ決済する。
export const coatingPaymentAffiliateId = (
  data: CreateCoatingParams,
  customerId: number,
  customerInfoId: number,
  originalAffiliateId: number,
  selectedTenant: SelectedTenant,
): number | null => {
  const tenant = selectedTenantFor(customerId, selectedTenant);
  const affiliateId = tenant?.m_affiliate_id ?? originalAffiliateId;

  if (
    customerId <= 0 ||
    customerInfoId !== customerId ||
    affiliateId <= 0 ||
    data.m_customer_id !== customerId ||
    data.m_affiliate_id !== affiliateId ||
    data.original_m_affiliate_id !== (tenant ? originalAffiliateId : undefined)
  ) {
    return null;
  }

  return affiliateId;
};

export const coatingPreparePaymentParams = (
  data: CreateCoatingParams,
  affiliateId: number,
  amount: number,
): PrepareCoatingPaymentParams => ({
  m_customer_id: data.m_customer_id,
  m_affiliate_id: affiliateId,
  amount,
  coating_item_code: data.coating_item_code,
  body_size: data.body_size,
  polish_option: data.polish_option,
});

export const coatingPaidyConfirmParams = (
  data: CreateCoatingParams,
  affiliateId: number,
  amount: number,
  paidyPaymentId: string,
): PaidyConfirmCoatingParams => ({
  ...coatingPreparePaymentParams(data, affiliateId, amount),
  paidy_payment_id: paidyPaymentId,
});

export const coatingGmoPaymentParams = (
  data: CreateCoatingParams,
  affiliateId: number,
  orderId: string,
  amount: number,
  completeUrl: string,
  cancelUrl: string,
): GmoPaymentUrlGenerationParams => ({
  m_affiliate_id: affiliateId.toString(),
  m_customer_id: data.m_customer_id.toString(),
  config_id: '1',
  order_id: orderId,
  amount: amount.toString(),
  complete_url: completeUrl,
  cancel_url: cancelUrl,
  member_id: `C${data.m_customer_id}_${affiliateId}`,
});
